"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@heron-web/material");
var _lab = require("@material-ui/lab");
var _hopsSdkJs = require("@hps/hops-sdk-js");
var _SingleIcon = _interopRequireDefault(require("./Icons/SingleIcon"));
var _ReturnIcon = _interopRequireDefault(require("./Icons/ReturnIcon"));
var _CircularIcon = _interopRequireDefault(require("./Icons/CircularIcon"));
var _RangerIcon = _interopRequireDefault(require("./Icons/RangerIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Toggle button control for ticket journey type selection
 * 
 * @package HOPS
 * @subpackage Tickets
 * @author Carl Booth
 * @copyright Heritage Operations Processing Limited
 */
class TicketJourneyTypeToggleButton extends _react.default.PureComponent {
  /**
   * Value changed.
   *
   * @param {Event} e
   * @return {void}
   */
  handleChange = (e, value) => {
    this.props.onChange(this.options[parseInt(value)]?.value, this.props.name);
  };

  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_lab.ToggleButtonGroup, {
      exclusive: true,
      onChange: this.handleChange,
      value: this.options.map(v => v.value).indexOf(this.props.value),
      children: this.options.map((option, key) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_lab.ToggleButton, {
          disabled: option.disabled,
          value: key,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Flex, {
            children: [option.icon, option.label]
          })
        }, key);
      })
    });
  }

  /**
   * Get our options.
   * 
   * @return {Array<Object>}
   */
  get options() {
    return Object.values(_hopsSdkJs.TicketJourneyTypes.values).filter(journeyType => this.props.hiddenOptions?.indexOf(journeyType) === -1).map(value => {
      return {
        icon: this.getJourneyTypeIcon(value),
        label: _hopsSdkJs.TicketJourneyTypes.getLabel(value),
        value,
        hidden: this.props.hiddenOptions?.includes(value)
      };
    });
  }

  /**
   * Get selected journey type icon and alt text.
   * 
   * @return {Object}
   */
  // eslint-disable-next-line class-methods-use-this
  getJourneyTypeIcon(value) {
    const journeyIcons = {
      [_hopsSdkJs.TicketJourneyTypes.values.Single]: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleIcon.default, {}),
      [_hopsSdkJs.TicketJourneyTypes.values.Return]: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReturnIcon.default, {}),
      [_hopsSdkJs.TicketJourneyTypes.values.Circular]: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularIcon.default, {}),
      [_hopsSdkJs.TicketJourneyTypes.values.Ranger]: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RangerIcon.default, {})
    };
    return journeyIcons[value];
  }
  static propTypes = {
    color: _propTypes.default.oneOf(["primary", "secondary"]),
    disabled: _propTypes.default.bool,
    onChange: _propTypes.default.func,
    row: _propTypes.default.bool,
    value: _propTypes.default.number
  };
  static defaultProps = {
    color: "primary",
    disabled: false,
    row: false
  };
}
var _default = TicketJourneyTypeToggleButton;
exports.default = _default;